export default "__VITE_ASSET__CjmzQyou__"